import styled from 'styled-components'
import { Illustration } from '../../../@types/config'
import { DEFAULT_LINK_COLOR, DEFAULT_TEXT_COLOR, LEGAL_TEXT_COLOR } from '../../constants'
import { default as ISStepTemplate } from '../../stepTemplate/StepTemplate'
import { TemplateProps } from '../../stepTemplate/StepTemplate'

type StyledStepTemplateProps = {
  backgroundColor?: string
  textColor?: string
  secondary?: string
  primary?: string
  primaryLight?: string
  secondaryLight?: string
  isIframe?: boolean
  illus?: Illustration
} & TemplateProps

const StepTemplate = styled(ISStepTemplate)`
  #rle-wizard & {
    ${(props: StyledStepTemplateProps) =>
      props.textColor &&
      `
    color: ${props.textColor}!important;
     .teasers,
     .progress-bar-info span,
     .headline,
     .area-step span,
     .list-check > li,
     .list-check > li::before,
     .status-secondary-text,
     .status-primary-text,
     .status-tertiary-text,
     .back-icon,
     .step-template-legal-note > p,
     .legal-note,
     .legal-note span,
     .legal-note a,
     .info-icon,
     .highlighter-text,
     .highlight-point,
     .location-name{
       color: ${props.textColor}!important;
     }
     .admin-tool-legal-note p,
     .admin-tool-teaser p {
      color:${props.textColor !== DEFAULT_TEXT_COLOR ? props.textColor : LEGAL_TEXT_COLOR} !important;
     }
     .btn-link{
     color:${props.textColor !== DEFAULT_LINK_COLOR ? props.textColor : DEFAULT_LINK_COLOR}!important
     }
  `}
    ${(props: StyledStepTemplateProps) =>
      props.backgroundColor &&
      `
     background-color: ${props.backgroundColor}!important;
  `}
  ${(props: StyledStepTemplateProps) =>
      props.primary &&
      `
     .is24-icon-positive-check{
       color: ${props.primary}!important;
     }
  `}
  ${(props: StyledStepTemplateProps) =>
      props.illus &&
      props.illus === Illustration.NEUTRAL &&
      `
    .highlighter,
    .highligher-area,
    .highlighter-bold {
      background: none!important;
      background-image:none!important;
    }
    .blue-bg{
      display: none
    }
  `}
  ${(props: StyledStepTemplateProps) =>
      props.secondaryLight &&
      `
    .wait-step {
      .non-verified-icon {
        color: ${props.secondaryLight} !important;
      }
    }
  `}
  ${(props: StyledStepTemplateProps) =>
      props.secondary &&
      `
     .wait-step {
        .is24-icon-positive-check{
          &:not(.non-verified-icon){
            color: ${props.secondary}!important;
          }
        }
     }
  `}
  }
`
export { StepTemplate }
